// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SEI_CustTable2"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = [{
  key: "AccountNum",
  label: "客户账号",
  sortable: true
},
{
  key: "SEI_Name",
  label: "客户名称",
  sortable: true
},
{
  key: "code",
  label: "类型",
  sortable: true
},
{
  key: "action",
  label: "操作",
  sortable: true
},
{
  key: "CreditMax",
  label: "金额",
  sortable: true,
  type: "number"
},
{
  key: "username",
  label: "操作用户",
  sortable: true,
},
{
  key: "FromDate",
  label: "开始日期",
  type: "date"
},
{
  key: "ToDate",
  label: "结束日期",
  type: "date"
},
{
  key: "log_at",
  label: "日志记录时间",
  sortable: true,
  type: "datetime",
},

]
const fields_detail = [{
  key: "id",
  label: "编号"
},
{
  key: "AccountNum",
  label: "客户账户"
},
{
  key: "CreditMax",
  label: "信用额度",
  type: "number"
},
{
  key: "is_approved",
  label: "是否审批"
},
{
  key: "approved_at",
  label: "审批日期"
},
{
  key: "approved_by",
  label: "待审批人"
},
{
  key: "create_at",
  label: "创建时间"
},
{
  key: "create_by",
  label: "创建人"
},
{
  key: "description",
  label: "备注"
},
{
  key: "update_by",
  label: "修改人"
},
{
  key: "update_at",
  label: "修改时间"
},
{
  key: "is_deleted",
  label: "是否删除"
},
{
  key: "deleted_by",
  label: "删除人"
},
{
  key: "deleted_at",
  label: "删除日期"
},
{
  key: "FromDate",
  label: "开始日期"
},
{
  key: "ToDate",
  label: "结束日期"
},
{
  key: "ext",
  label: "ext"
},
{
  key: "Credit_Id",
  label: "信用编号"
},
]

const dataForm = {}
///前端验证
const rules = {}

const methods = {
  actionChange(t) {
    switch (t.action) {
      case "a":
        t.action = "审核"
        break
      case "u":
        t.action = "修改"
        break
      case "d":
        t.action = "删除"
        break
      case "i":
        t.action = "新增"
        break
      case "s":
        t.action = "查询"
        break
      case "r":
        t.action = "移除"
        break
      default:
        break
    }
  },
  ///get
  async getData(_params) {
    let _this = this
    const log_biz_data = new biz_data_helper.base_entity_helper(
      "get_credit_control_log", {}, {}
    )
    let _fields = _.map(fields, "key")
    _fields.push("data")
    let result = await log_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {

      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
}
export {
  biz_data, dataForm, fields, fields_detail, methods,
  rules
};

